import { ca } from '@cian/analytics';
import { TPromoType } from '../../types/newBuldings/promo';

export function trackOpenDiscount(discountType: TPromoType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_promotions_builder',
    label: discountType,
    useLastProducts: true,
  });
}
